import { createFileRoute, Outlet, redirect, useNavigate } from "@tanstack/react-router";
import { multiFactor } from "firebase/auth";
import { useEffect } from "react";
import { authSettled, getFirebase } from "@/lib/firebase";
import { useAuth } from "@/lib/auth";
import { shouldBounceToLogin } from "@/lib/auth-guard";
import { AppShell } from "@/components/AppShell";

export const Route = createFileRoute("/_authed")({
  beforeLoad: async ({ location }) => {
    const user = await authSettled(getFirebase().auth);
    if (!user) {
      throw redirect({ to: "/login", search: { next: location.pathname } });
    }
    if (multiFactor(user).enrolledFactors.length === 0) {
      throw redirect({ to: "/mfa-enroll" });
    }
    const tok = await user.getIdTokenResult();
    if (tok.claims.role !== "platform_admin") {
      throw redirect({ to: "/forbidden" });
    }
  },
  component: AuthedLayout,
});

function AuthedLayout() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  // beforeLoad runs only on route entry. Without this effect, sign-out clears
  // auth state but the user stays on the authed page until they hard-reload.
  // `auth.currentUser` (not just the context's `user`) breaks the race right
  // after TOTP verification — see auth-guard.ts.
  useEffect(() => {
    if (shouldBounceToLogin({ loading, contextUser: user, sdkUser: getFirebase().auth.currentUser })) {
      void navigate({ to: "/login", replace: true });
    }
  }, [loading, user, navigate]);

  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
